<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import RoutesRequest from 'Modules/contacard/banners/banner_routes/RoutesRequest';

export default {
  name: 'RoutesCrudList',
  extends: CrudListVue,
  data: () => ({
    requestClass: RoutesRequest,
    editRoute: 'banner.route.edit',
    headers: [
      {
        text: 'Nome',
        value: 'name',
      },
      {
        text: 'Rota',
        value: 'routeName',
      },
    ],
  }),
};
</script>
